import { Component, OnInit, Output, Input, HostListener, OnDestroy, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { PopupWindowService } from '@EfsServices/popup-window.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EfsUser } from './shared/models/efs.model';
import { EfsApiService } from './shared/services/efs-api.service';
import { SessionService } from './shared/services/session.service';
import { environment } from '../environments/environment';
import { DataSharingService } from '@EfsServices/data-sharing.service';
import { HttpClient } from '@angular/common/http';
import { MatSidenav } from '@angular/material/sidenav';

import { CookieService } from 'ngx-cookie-service';
// import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GuardLinkService } from '@EfsServices/guard-link.service';
import { PermissionHandlingService } from '@efsShared/services/permission-handling.service';
import { ApiErrorHandlingService } from '@EfsServices/api-error-handling.service';
import { GenericPopupComponent } from '@EfsReusable/generic-popup/generic-popup.component';
import { LoggingService } from '@EfsServices/logging.service';

import { SessionTimerService } from '@EfsServices/session-timer.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  currentModule = 'General'; // default value
  currentYear = new Date().getFullYear();
  title = 'EFS-application';
  userRoles;
  efsUser: EfsUser;
  version = environment.version;
  doneLoading = true;
  timeout;
  finalCountDown;
  popupDialogRef;
  opened: boolean;

  dashboardRead = '';
  siRead = '';
  phRead = '';
  dmRead = '';
  psRead = '';
  ptRead = '';
  pmRead = '';
  paRead = '';
  csRead = '';
  rsRead = '';

  //for national dispatch template and national corp setup
  ndiRead = '';
  ncpRead = '';
  ndiWrite = '';
  ncpWrite = '';

  dashboardWrite = '';
  siWrite = '';
  phWrite = '';
  dmWrite = '';
  psWrite = '';
  ptWrite = '';
  pmWrite = '';
  paWrite = '';
  csWrite = '';
  rsWrite = '';

  moduleName = '';
  moduleVersion = '';

  urlParamData = '';

  nativeWindow: any;

  // pdfSrc = 'https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf';
  pdfSrc = 'src/assets/EFS_Special_Ins_userguide.pdf';

  lockDown = false;
  browser;
  ieMessage = false;
  lockdownMsg = false;

  constructor(
    private winRef: PopupWindowService,
    private guardLinkService: GuardLinkService,
    private router: Router,
    // private spinnerService: Ng4LoadingSpinnerService,
    private efsApiService: EfsApiService,
    private sessionService: SessionService,
    private cookieService: CookieService,
    private dataSharingService: DataSharingService,
    private httpClient: HttpClient,
    private route: ActivatedRoute,
    public permissionHandlingService: PermissionHandlingService,
    private apiErrorHandlingService: ApiErrorHandlingService,
    public dialog: MatDialog,
    private sessionTimerService: SessionTimerService,
    private cd: ChangeDetectorRef,
    public loggingService: LoggingService,
  ) { }

  ngOnInit() {
    // check for browser, dont use ie for now
    this.browser = navigator.userAgent;
    console.log('browser is ' + this.browser);
    if (navigator.userAgent.indexOf('rv:11.0') !== -1) {
      console.log('ie detected!');
      this.ieMessage = true;
      this.lockdownMsg = false;
      this.lockDown = true;
    } else {
      console.log('not detected!');
    }
    /**
     * temporary code to work-around no-connectivity to on prem services in AWS FOR TESTING
     */
    // if (environment.envName === 'dev') {
    //   const addMinutes = (date, minutes) => {
    //     return new Date(date.getTime() + minutes * 60000);
    //   };
    //   const userName = '324360';
    //   const webSessionId = 'mPMLhrcqYnm22P3ScJ9M-DNg.node2';
    //   // tslint:disable-next-line:max-line-length
    //   const token = ''
    //   this.cookieService.set('userNm', userName, addMinutes(new Date(), 60));
    //   this.cookieService.set('web_session_id', webSessionId, addMinutes(new Date(), 60));
    //   this.cookieService.set('token', token, addMinutes(new Date(), 60));
    // }
    /** end of temporary code TODO: REMOVE THIS CODE */

    this.doneLoading = true;
    this.sessionService.setHttpOptions();
    // this.efsApiService.getAllCurrentlyAllowedFacilities();
    // this.efsApiService.logInfoEvent('User landed on main setup page');
    this.serviceDataSharing();
    // check for permissions before allowing this call to be made
    if (sessionStorage.getItem('allowRoles') === 'true') {
      this.getUserRole();
    }
    // this.setPermissions();

    /**
     * set up timer to check whether the session is still alive. after 15 minutes of inactivity, session will
     * be considered dead. Movement of mouse or keyboard will reset the session. if the session is dead, user will be
     * removed back to customer center.
     */
    // this.timeout = setTimeout(() => {
    //   console.log('Time is up');
    //   this.serviceIsActiveUser();
    // }, 900500); // 900500
    // console.log('Kickout Timer is about to start');
    // this.checkSessionStatus();
    // session timer startup for detecting session
    this.sessionTimer();
  }
  // stop session timers once the modal is removed
  ngOnDestroy(): void {
    this.sessionTimerService.stopTimers();
  }
  // session timer method for tracking session using mouse movement
  @HostListener('mousemove')
  sessionTimer() {
    this.sessionTimerService.checkSessionStatus();
  }

  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    this.cd.detectChanges();
  }

  // services
  serviceDataSharing() {
    this.dataSharingService.observableItem$.subscribe(data => {
      if (data === 'updateHelp') {
        console.log('update help');
        this.currentModule = 'General';
      } else if (data === 'rulesetup') {
        this.currentModule = 'Rule Setup';
      } else {
        this.setModuleInfo(data);
      }

    });
  }

  setPermissions(rulePermission) {
    // TODO define the session storage name once they exist;
    // TEMPORARY ALLOW USER ACCESS TO DELAYED MAIL AND PRODUCTION SETUP IF THEY HAVE PREHOLD ACCESS,
    // REMOVE ACCESS AND REPLACE WITH RESPECTIVE ROLES ONCE THEY EXIST

    /* Release of modules are on a schedule, Environment will restrict access to individual modules.
       DEV and QA will have access to all modules at all times, UAT will have release ready modules only
    */
    // including uat for testing all template modules
    if (environment.envName === 'dev' || environment.envName === 'QA' || environment.envName === 'INT' || environment.envName === 'UAT') {

      // search through the map and set each permission handling service variable accordingly




      if (this.permissionHandlingService.permissionsMap.get('EFS-DASHBOARD READ') === true) {
        this.permissionHandlingService.dashboardRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-DASHBOARD WRITE') === true) {
        this.permissionHandlingService.dashboardWrite = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-NATIONAL DISPATCH TEMPLATE READ') === true) {
        this.permissionHandlingService.ndiRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-NATIONAL DISPATCH TEMPLATE WRITE') === true) {
        this.permissionHandlingService.ndiWrite = true;
      }
      //for national Setup : national corp setup

      if (this.permissionHandlingService.permissionsMap.get('EFS-NATIONAL CORP SETUP READ') === true) {
        this.permissionHandlingService.ncpRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-NATIONAL CORP SETUP WRITE') === true) {
        this.permissionHandlingService.ncpWrite = true;
      }
      //************

      if (this.permissionHandlingService.permissionsMap.get('EFS-SPECIAL INST READ') === true) {
        this.permissionHandlingService.siRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-SPECIAL INST WRITE') === true) {
        this.permissionHandlingService.siWrite = true;
      }


      if (this.permissionHandlingService.permissionsMap.get('EFS-PREHOLD TEMPLATE READ') === true) {
        this.permissionHandlingService.phRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-PREHOLD TEMPLATE WRITE') === true) {
        this.permissionHandlingService.phWrite = true;
      }


      if (this.permissionHandlingService.permissionsMap.get('EFS-PRODUCTION TEMPLATE READ') === true) {
        this.permissionHandlingService.psRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-PRODUCTION TEMPLATE WRITE') === true) {
        this.permissionHandlingService.psWrite = true;
      }


      if (this.permissionHandlingService.permissionsMap.get('EFS-PLAN TEMPLATE READ') === true) {
        this.permissionHandlingService.ptRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-PLAN TEMPLATE WRITE') === true) {
        this.permissionHandlingService.ptWrite = true;
      }


      if (this.permissionHandlingService.permissionsMap.get('EFS-PROD METHOD GROUP READ') === true) {
        this.permissionHandlingService.pmRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-PROD METHOD GROUP WRITE') === true) {
        this.permissionHandlingService.pmWrite = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-PREHOLD TEMPLATE READ') === true) {
        this.permissionHandlingService.paRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-PREHOLD TEMPLATE READ') === true) {
        this.permissionHandlingService.dmRead = true;
      }

      // corp setup
      if (this.permissionHandlingService.permissionsMap.get('EFS-CORP SET UP READ') === true) {
        this.permissionHandlingService.csRead = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-CORP SET UP WRITE') === true) {
        this.permissionHandlingService.csWrite = true;
      }

      // rule setup
      if (this.permissionHandlingService.permissionsMap.get('EFS-RULE SLA READ') === true) {
        this.permissionHandlingService.slaRead = true;
        this.permissionHandlingService.rsRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-RULE SLA WRITE') === true) {
        this.permissionHandlingService.slaWrite = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-RULE FDM READ') === true) {
        this.permissionHandlingService.fdmRead = true;
        this.permissionHandlingService.rsRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-RULE FDM WRITE') === true) {
        this.permissionHandlingService.fdmWrite = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS- MID READ') === true) {
        this.permissionHandlingService.midRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS- MID WRITE') === true) {
        this.permissionHandlingService.midWrite = true;
      }

      // role admin
      if (this.permissionHandlingService.permissionsMap.get('ROLE ADMIN') === true) {
        this.permissionHandlingService.raWrite = true;
      }

    } else if (environment.envName === 'PROD' || environment.envName === 'UAT') {
      // UAT and PROD are high environments, will only have release modules here
      // special instructions
      if (this.permissionHandlingService.permissionsMap.get('EFS-DASHBOARD READ') === true) {
        this.permissionHandlingService.dashboardRead = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-DASHBOARD WRITE') === true) {
        this.permissionHandlingService.dashboardWrite = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-SPECIAL INST READ') === true) {
        this.permissionHandlingService.siRead = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-SPECIAL INST WRITE') === true) {
        this.permissionHandlingService.siWrite = true;
      }

      // prehold
      if (this.permissionHandlingService.permissionsMap.get('EFS-PREHOLD TEMPLATE READ') === true) {
        this.permissionHandlingService.phRead = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-PREHOLD TEMPLATE WRITE') === true) {
        this.permissionHandlingService.phWrite = true;
      }

      // production setup
      if (this.permissionHandlingService.permissionsMap.get('EFS-PRODUCTION TEMPLATE READ') === true) {
        this.permissionHandlingService.psRead = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-PRODUCTION TEMPLATE WRITE') === true) {
        this.permissionHandlingService.psWrite = true;
      }

      // plan template
      if (this.permissionHandlingService.permissionsMap.get('EFS-PLAN TEMPLATE READ') === true) {
        this.permissionHandlingService.ptRead = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-PLAN TEMPLATE WRITE') === true) {
        this.permissionHandlingService.ptWrite = true;
      }

      // prod method
      if (this.permissionHandlingService.permissionsMap.get('EFS-PROD METHOD GROUP READ') === true) {
        this.permissionHandlingService.pmRead = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-PROD METHOD GROUP WRITE') === true) {
        this.permissionHandlingService.pmWrite = true;
      }

      // package template, currently inactive
      // if (this.permissionHandlingService.permissionsMap.get('EFS-PREHOLD TEMPLATE READ') === 'EFS-PREHOLD TEMPLATE READ') {
      //   this.permissionHandlingService.paRead = true;
      // }

      // if (this.permissionHandlingService.permissionsMap.get('EFS-PREHOLD TEMPLATE READ') === 'EFS-PREHOLD TEMPLATE READ') {
      //   this.permissionHandlingService.dmRead = true;
      // }

      // corp setup
      if (this.permissionHandlingService.permissionsMap.get('EFS-CORP SET UP READ') === true) {
        this.permissionHandlingService.csRead = true;
      }
      if (this.permissionHandlingService.permissionsMap.get('EFS-CORP SET UP WRITE') === true) {
        this.permissionHandlingService.csWrite = true;
      }

      // rule setup
      if (this.permissionHandlingService.permissionsMap.get('EFS-RULE SLA READ') === true) {
        this.permissionHandlingService.slaRead = true;
        this.permissionHandlingService.rsRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-RULE SLA WRITE') === true) {
        this.permissionHandlingService.slaWrite = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-RULE FDM READ') === true) {
        this.permissionHandlingService.fdmRead = true;
        this.permissionHandlingService.rsRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS-RULE FDM WRITE') === true) {
        this.permissionHandlingService.fdmWrite = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS- MID READ') === true) {
        this.permissionHandlingService.midRead = true;
      }

      if (this.permissionHandlingService.permissionsMap.get('EFS- MID WRITE') === true) {
        this.permissionHandlingService.midWrite = true;
      }

      // role admin
      if (this.permissionHandlingService.permissionsMap.get('ROLE ADMIN') === true) {
        this.permissionHandlingService.raWrite = true;
      }

    }
  }

  // alert when navigating from sidenav
  fromNav() {
    this.dataSharingService.shareData('from nav');
  }

  navigateTo(moduleName) { // validate the link and navigate. add any new modules here
    this.guardLinkService.validateLink().subscribe(() => {
      // this.toggleSearchSI = true;
      if (moduleName === 'special instructions') {
        this.router.navigate(['setup/searchSpecialInstructions']);
        this.currentModule = moduleName;
      }
      if (moduleName === 'prehold') {
        this.router.navigate(['setup/prehold']);
        this.currentModule = moduleName;
      }
      if (moduleName === 'delayed mail') {
        this.router.navigate(['setup/delayedMail']);
        this.currentModule = moduleName;
      }
      if (moduleName === 'production setup') {
        this.router.navigate(['setup/productionSetup']);
        this.currentModule = moduleName;
      }
      if (moduleName === 'production method group') {
        this.router.navigate(['setup/productionMethod']);
        this.currentModule = moduleName;
      }
      if (moduleName === 'plan template') {
        this.router.navigate(['setup/planTemplate']);
        this.currentModule = moduleName;
      }
      if (moduleName === 'package template') {
        this.router.navigate(['setup/packageTemplate']);
        this.currentModule = moduleName;
      }
      if (moduleName === 'corp setup') {
        this.router.navigate(['setup/corpSetup']);
        this.dataSharingService.shareData('moduleCS');
        this.currentModule = moduleName;
      }
      if (moduleName === 'rule setup') {
        this.router.navigate(['setup/ruleSetup']);
        this.currentModule = moduleName;
        sessionStorage.removeItem('ruleClassNm');
      }
      if (moduleName === 'national dispatch template') {
        this.router.navigate(['nationalSetup/nationalDispatchTemplate']);
        this.currentModule = moduleName;
      }
      if (moduleName === 'national corp setup') {
        this.router.navigate(['nationalSetup/nationalCorpSetup']);
        this.currentModule = moduleName;
      }
      if (moduleName === 'client summary') {
        this.router.navigate(['clientSummary']);
        this.currentModule = moduleName;
      }
      if (moduleName === 'corpSlaExportReport') {
        this.router.navigate(['corpSlaExportReport']);
        this.currentModule = 'General';
      }
      if (moduleName === 'singleUserSetupICC') {
        this.router.navigate(['singleUserSetupICC']);
        this.currentModule = 'General';
      }
      if (moduleName === 'mailerIdSetup') {
        this.router.navigate(['setup/mailerIdSetup']);
        this.currentModule = 'General';
      }
      if (moduleName === 'parameterEntry') {
        this.router.navigate(['setup/parameterEntry']);
        this.currentModule = 'General';
      }
      if (moduleName === 'perfMeasurements') {
        this.router.navigate(['setup/perfMeasurements']);
        this.currentModule = 'General';
      }
      if (moduleName === 'corpProfileSetup') {
        this.router.navigate(['setup/corpProfileSetup']);
        this.currentModule = 'General';
      }
      if (moduleName === 'archivalAndRetrieval') {
        this.router.navigate(['archival-and-retrieval']);
        this.currentModule = 'General';
      }
      if (moduleName === 'MKBillOfMaterial') {
        this.router.navigate(['mk-bill-of-material']);
        this.currentModule = 'General';
      }
    });
  }

  setModuleInfo(data) { // get version of module for display purposes if debugging
    console.log('setModuleInfo');
    if (data.moduleName === 'moduleSI') {
      this.moduleName = 'Special Instructions';
      this.moduleVersion = data.moduleVersion;
      this.currentModule = 'Special Instructions';
    } else if (data.moduleName === 'modulePH') {
      console.log('DID I RUN MODULE NAME' + data.moduleVersion);
      this.moduleName = 'Prehold';
      this.moduleVersion = data.moduleVersion;
      this.currentModule = 'Prehold';
    } else if (data.moduleName === 'moduleDM') {
      this.moduleName = 'Delayed Mail';
      this.moduleVersion = data.moduleVersion;
      this.currentModule = 'Delayed Mail';
    } else if (data.moduleName === 'modulePS') {
      this.moduleName = 'Production Setup';
      this.moduleVersion = data.moduleVersion;
      this.currentModule = 'Production Setup';
    } else if (data.moduleName === 'modulePM') {
      this.moduleName = 'Production Method Group';
      this.moduleVersion = data.moduleVersion;
      this.currentModule = 'Production Method Group';
    } else if (data.moduleName === 'modulePT') {
      this.moduleName = 'Plan Template';
      this.moduleVersion = data.moduleVersion;
      this.currentModule = 'Plan Template';
    } else if (data.moduleName === 'modulePA') {
      this.moduleName = 'Package Template';
      this.currentModule = 'Package Template';
    } else if (data.moduleName === 'moduleCS') {
      this.moduleName = 'Corp Setup';
      this.currentModule = 'Corp Setup';
    } else if (data.moduleName === 'moduleRS') {
      this.moduleName = 'Rule Setup';
      this.currentModule = 'Rule Setup';
    } else if (data.moduleName === 'moduleNCS') {
      this.moduleName = 'National Corp Setup';
      this.currentModule = 'National Corp Setup';
    } else if (data.moduleName === 'moduleNPA') {
      this.moduleName = 'National Package Template';
      this.currentModule = 'National Package Template';
    } else if (data.moduleName === 'moduleNDI') {
      this.moduleName = 'National Dispatch Template';
      this.currentModule = 'National Dispatch Template';
    } else if (data.moduleName === 'moduleRA') {
      this.moduleName = 'Role Administration';
      this.currentModule = 'Role Administration';
    } else if (data.moduleName === 'moduleCS') {
      this.moduleName = 'Client Summary';
      this.currentModule = 'Client Summary';
    } else if (data.moduleName === 'moduleMailerIdSetup') {
      this.moduleName = 'Mailer ID Setup';
      this.currentModule = 'Mailer ID Setup';
    } else if (data.moduleName === 'moduleSUSICC') {
      this.moduleName = 'Single User Setup ICC';
      this.currentModule = 'Single User Setup ICC';
    } else if (data.moduleName === 'moduleSUSICC') {
      this.moduleName = 'Parameter Entry';
      this.currentModule = 'Parameter Entry';
    } else if (data.moduleName === 'modulePerfMeasurements') {
      this.moduleName = 'Perf Measurements';
      this.currentModule = 'Perf Measurements';
    } else if (data.moduleName === 'moduleCorpProfileSetup') {
      this.moduleName = 'Corp Profile Setup';
      this.currentModule = 'Corp Profile Setup';
    } else if (data.moduleName === 'moduleAR') {
      this.moduleName = 'Archival and Retrieval';
      this.currentModule = 'Archival and Retrieval';
    } else if (data.moduleName === 'moduleBOM') {
      this.moduleName = 'MK Bill of Material';
      this.currentModule = 'MK Bill of Material';
    }
    // detect the new value used
    this.cd.detectChanges();
  }

  // @HostListener('mousemove')
  // checkSessionStatus() {
  //   // console.log('MOUSE MOVED!!!');
  //   // console.log(this.timeout);
  //   clearTimeout(this.timeout);
  //   this.timeout = setTimeout(() => {
  //     console.log('Time is up');
  //     this.expireUser();
  //     this.popupWarning(true, 'Session expiring', 'Session will expire in 1 minute, would you like to continue?');
  //     // this.serviceIsActiveUser();
  //   }, 5000); // 840000 is 14 minutes
  // }

  /**
   * Begins final 3 minute interruptable timer to expire user. If user clicks yes, the timer is refreshed, call to
   * isActiveUser refreshes session and user is allowed to continue. If user clicks no, user is immediately dumped to
   * customer center. If user waits out final 3 minutes, user is dumped to Customer Center
   */
  // expireUser() {
  //   this.finalCountDown = setTimeout(() => {
  //     console.log('USER EXPIRED, USER WILL BE SENT TO CUSTOMER CENTER');
  //     if (environment.envName !== 'dev') {
  //       // send user back to CC
  //       sessionStorage.clear();
  //       document.location.href = this.efsApiService.redirectUrl;
  //     } else {
  //       this.dialog.closeAll();
  //       this.checkSessionStatus();
  //     }
  //   }, 60000); // 60000 is 1 minutes
  // }

  serviceIsActiveUser() {
    this.sessionService.isActiveUser().subscribe(data => {
      console.log('is active user' + data);
      // this.router.navigate(['setup']); // not used in this component
      // after calling this method, if user is active, restart the countdown
      // this.checkSessionStatus();
      this.sessionTimerService.checkSessionStatus();
    }, error => {
      // any error in this service should result in the user being kicked
      // this.apiErrorHandlingService.errorStatusHandler(error);
      // Active User Service failed, kick user from application
      if (environment.envName !== 'dev') {
        sessionStorage.clear();
        this.loggingService.logInfo('User Was kicked out by ServiceIsActiveUser in AppComponent');
        document.location.href = this.efsApiService.redirectUrl;
      } else if (environment.envName === 'dev') {
        alert('Session is expired ' + JSON.stringify(error));
      }
    });
  }

  popupWarning(questionType, title, message) {
    this.popupDialogRef = this.dialog.open(GenericPopupComponent, {
      width: '450px',
      height: '275px',
      panelClass: 'popup-borders',
      disableClose: true,
      data: {
        questionType,
        title,
        message
      }
    }).afterClosed().subscribe(result => {
      // a button has been pressed, make sure the final Countdown is shut down dodododoo
      clearTimeout(this.finalCountDown);
      if (result) { // user clicked yes
        console.log('clicked yes');
        this.serviceIsActiveUser();
      } else if (!result) { // user clicked no
        console.log('clicked no');
        if (environment.envName !== 'dev') {
          sessionStorage.clear();
          this.loggingService.logInfo('User Was kicked out by popupWarning in AppComponent');
          document.location.href = this.efsApiService.redirectUrl;
        }
      }
    });
    // return true;
  }

  helpFunction() {
    console.log('Hello! module is ' + this.currentModule);
    sessionStorage.setItem('helpPage', this.currentModule);
    const url = this.router.serializeUrl(this.router.createUrlTree(['helpPage']));
    console.log('show url ' + url);
    window.open(url, '_blank');
    // this.router.navigate(['helpPage']);
    // this.dataSharingService.shareData(this.currentModule);
  }

  // render local pdfs
  // onFileSelected() {
  //   const $img: any = document.querySelector('#file');

  //   if (typeof (FileReader) !== 'undefined') {
  //     const reader = new FileReader();

  //     reader.onload = (e: any) => {
  //       this.pdfSrc = e.target.result;
  //     };

  //     reader.readAsArrayBuffer($img.files[0]);
  //   }
  // }

  public getUserRole() { // call efs service getUserRoles and use session storage userid to retrieve role
    // const userName = sessionStorage.getItem('username');
    // loading spinner?
    this.efsApiService.getUserRoles(this.cookieService.get('userNm').toUpperCase()).subscribe((userRole: any) => { // must be uppercase
      this.userRoles = userRole;
      // dynamic role list
      this.permissionHandlingService.createReadWritePermissions(this.userRoles);
      // console.log(JSON.stringify(this.userRoles));
      if (this.cookieService.get('callerId') === 'travellerSetup') {
        sessionStorage.setItem('EFS-PRODUCTION TEMPLATE READ', 'travellerSetup');
        sessionStorage.setItem('EFS-PRODUCTION TEMPLATE WRITE', 'travellerSetup');
      } else {
        for (const detail of this.userRoles.details) { // set all user roles
          for (const role of detail.roles) {
            // console.log('USER ROLES ' + JSON.stringify(role));
            // special security for role admin that should be expanded to all
            if (role.rolesDesc.toUpperCase() === 'ROLE ADMIN') {
              // const roleAdminToken = Math.random().toString();
              // this.raWriteKey = roleAdminToken;
              // sessionStorage.setItem(role.rolesDesc.toUpperCase(), btoa(roleAdminToken));
              this.setPermissions(role.rolesDesc.toUpperCase());
            } else {
              this.setPermissions(role.rolesDesc.toUpperCase());
              if (role.rolesDesc.toUpperCase().match('EFS-RULE ')) {
                console.log('efs rule match');
                this.permissionHandlingService.rsRead = true;
              }

              // sessionStorage.setItem(role.rolesDesc.toUpperCase(), role.rolesDesc.toUpperCase());
            }
          }
        }
      }
    }, error => {
      this.apiErrorHandlingService.errorStatusHandler(error);
    });
  }

}
